"use client";

import { AuthProvider, withAuth } from "@/components";
import type { TPropsWithOptionalChildren } from "@/types/component.types";
import { Suspense } from "react";

// Component that wraps its children with authentication
export default function WithAuth({ children }: TPropsWithOptionalChildren) {
	const AuthWrapper = withAuth(({ children }) => (
		// eslint-disable-next-line react/jsx-no-useless-fragment
		<>{children}</>
	));

	return (
		<Suspense>
			<AuthProvider>
				<AuthWrapper>{children}</AuthWrapper>
			</AuthProvider>
		</Suspense>
	);
}
